import { Button, Collapse, Form, Input, Table } from 'antd';
import Paragraph from 'antd/es/typography/Paragraph';
import Text from 'antd/es/typography/Text';
import { FormInstance } from 'antd/lib/form/Form';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { formatChatDate } from '../../../utils';
import { ICreateNewsForm } from '../store';

class _News extends Component<IRootStoreProps> {
  private _formRef = React.createRef<FormInstance>();

  componentDidMount(): void {
    this.props.store.console.getAllNews();
  }

  render() {
    const { store } = this.props;
    const { console, loading } = store;

    const columns = [
      { title: 'Id', dataIndex: 'newsId', key: 'newsId' },
      { title: 'Название', dataIndex: 'title', key: 'title' },
      {
        title: 'Текст',
        dataIndex: 'body',
        key: 'body',
        render: (body: string) => <Paragraph style={{ whiteSpace: 'pre-wrap', marginTop: 24 }}>{body}</Paragraph>,
      },
      {
        title: 'Дата',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (item: string) => {
          const { date, time } = formatChatDate(item);

          return <Text type="secondary">{`${date || ''} ${time}`}</Text>;
        },
      },
    ];
    const layout = {
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
    };

    return (
      <>
        <Collapse
          size="small"
          items={[
            {
              key: '1',
              label: 'Создание новости',

              children: (
                <Form
                  {...layout}
                  ref={this._formRef}
                  onFinish={this._handleFinish}
                  style={{ maxWidth: 800 }}
                  initialValues={{}}
                >
                  <Form.Item<ICreateNewsForm> name={'title'} label="Заголовок" rules={[{ required: true }]}>
                    <Input />
                  </Form.Item>

                  <Form.Item<ICreateNewsForm> name={'body'} label="Текст" rules={[{ required: true }]}>
                    <Input.TextArea rows={6} />
                  </Form.Item>
                  <Form.Item label={null}>
                    <Button type="primary" htmlType="submit">
                      Создать
                    </Button>
                  </Form.Item>
                </Form>
              ),
            },
          ]}
          style={{ marginBottom: 10 }}
        />
        <Table
          columns={columns}
          dataSource={console.news}
          loading={loading}
          pagination={{ total: console.totalNews, pageSize: console.tableParams.limit }}
          onChange={console.handleTableChangeNews}
        />
      </>
    );
  }

  private _handleFinish = async (values: ICreateNewsForm) => {
    const { store } = this.props;
    const { console } = store;

    await console.createNews(values);
    if (this._formRef.current) {
      this._formRef.current.resetFields();
    }
  };
}

export const NewsPage: WithoutStore = withStore(observer(_News));
